import { Link } from 'react-router-dom';

const Blogs = () => {
    return ( 
        <div className="section techwix-blog-grid-section section-padding">
            <div className="container">
                <div className="techwix-blog-grid-wrap">
                    <div className="row">
                    <div className="col-lg-4 col-md-6">
                            <div className="single-blog">
                                <div className="blog-image">
                                    <Link to="#"><img src="assets/images/blog/blog-1.jpg" alt="" /></Link>
                                    <div className="top-meta">
                                        <span className="date"><span>19</span>Aug</span>
                                    </div>
                                </div>
                                <div className="blog-content">
                                    <div className="blog-meta">
                                        <span><i className="fas fa-user"></i> <Link to="#">Andrew Paker</Link></span>
                                        <span><i className="far fa-comments"></i> 0 Comments</span>
                                    </div>
                                    <h3 className="title"><Link to="#">What OneBiss is All About </Link></h3>
                                    <div className="blog-btn">
                                        <Link className="blog-btn-link" to="#">Read Full <i className="fas fa-long-arrow-alt-right"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="single-blog">
                                <div className="blog-image">
                                    <Link to="#"><img src="assets/images/blog/blog-2.jpg" alt="" /></Link>
                                    <div className="top-meta">
                                        <span className="date"><span>04</span>Sep</span>
                                    </div>
                                </div>
                                <div className="blog-content">
                                    <div className="blog-meta">
                                        <span><i className="fas fa-user"></i> <Link to="#">Andrew Paker</Link></span>
                                        <span><i className="far fa-comments"></i> 0 Comments</span>
                                    </div>
                                    <h3 className="title"><Link to="#">FAQ About OneBiss </Link></h3>
                                    <div className="blog-btn">
                                        <Link className="blog-btn-link" to="#">Read Full <i className="fas fa-long-arrow-alt-right"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="single-blog">
                                <div className="blog-image">
                                    <Link to="#"><img src="assets/images/blog/blog-3.jpg" alt="" /></Link>
                                    <div className="top-meta">
                                        <span className="date"><span>12</span>Oct</span>
                                    </div>
                                </div>
                                <div className="blog-content">
                                    <div className="blog-meta">
                                        <span><i className="fas fa-user"></i> <Link to="#">Admin</Link></span>
                                        <span><i className="far fa-comments"></i> 0 Comments</span>
                                    </div>
                                    <h3 className="title"><Link to="#">Easy and Most Powerful Server and Platform.</Link></h3>
                                    <div className="blog-btn">
                                        <Link className="blog-btn-link" to="#">Read Full <i className="fas fa-long-arrow-alt-right"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </div>                                                
                    </div>
                    {/*<div className="techwix-pagination">
                        <ul className="pagination justify-content-center">
                            <li><Link to="#"><i className="fa fa-angle-left"></i></Link></li>
                            <li><Link to="blog.html">1</Link></li>
                            <li><Link className="active" to="blog.html">2</Link></li>
                            <li><Link to="blog.html">3</Link></li>
                            <li><span>...</span></li>
                            <li><Link to="blog.html"><i className="fa fa-angle-right"></i></Link></li>
                        </ul>
    </div> */}
                </div>
            </div>
        </div>
     );
}
 
export default Blogs;